var _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4814 12.1624C6.20549 12.4383 6.20549 12.8857 6.4814 13.1616C6.75732 13.4375 7.20466 13.4375 7.48057 13.1616L6.4814 12.1624ZM9.64462 9.99835L10.1442 10.4979C10.4201 10.222 10.4201 9.77468 10.1442 9.49877L9.64462 9.99835ZM7.48057 6.83513C7.20466 6.55922 6.75732 6.55922 6.4814 6.83513C6.20549 7.11104 6.20549 7.55839 6.4814 7.8343L7.48057 6.83513ZM7.48057 13.1616L10.1442 10.4979L9.14504 9.49877L6.4814 12.1624L7.48057 13.1616ZM10.1442 9.49877L7.48057 6.83513L6.4814 7.8343L9.14504 10.4979L10.1442 9.49877Z",
    fill: "url(#paint0_linear_175_304)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.214 13.0715C9.93806 13.3474 9.93806 13.7947 10.214 14.0706C10.4899 14.3465 10.9372 14.3465 11.2131 14.0706L10.214 13.0715ZM14.285 9.99962L14.7846 10.4992C15.0605 10.2233 15.0605 9.77595 14.7846 9.50003L14.285 9.99962ZM11.2131 5.92861C10.9372 5.65269 10.4899 5.65269 10.214 5.92861C9.93806 6.20452 9.93806 6.65186 10.214 6.92778L11.2131 5.92861ZM11.2131 14.0706L14.7846 10.4992L13.7854 9.50003L10.214 13.0715L11.2131 14.0706ZM14.7846 9.50003L11.2131 5.92861L10.214 6.92778L13.7854 10.4992L14.7846 9.50003Z",
    fill: "url(#paint1_linear_175_304)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.29347,
    transform: "rotate(-180 10 10)",
    stroke: "url(#paint2_linear_175_304)",
    strokeWidth: 1.41304
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_304",
    x1: 6.98099,
    y1: 7.33472,
    x2: 11.0943,
    y2: 11.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_304",
    x1: 10.7136,
    y1: 6.42819,
    x2: 16.2287,
    y2: 11.4263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_175_304",
    x1: 20,
    y1: 0.0000104904,
    x2: -3.79217,
    y2: 13.1266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA23D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2BBFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrap);
export default __webpack_public_path__ + "static/media/icon_wrap.64cd9e3095c4efc1918fb9a269762eca.svg";
export { ForwardRef as ReactComponent };